
(function($) {
    $(document).ready(function () {
        restaurantMenus();
    });

    function restaurantMenus() {
        var wrap = $('.section.menus_carousel .slider'),
        children = wrap.find('.item_wrap'),
        hasCarousel = false;
        console.log('children >', children.length);

        if(children.length > 3){
            hasCarousel = true;
        } else {
            if(is_mobile && children.length > 2){
                hasCarousel = true;
            }
            if(is_phone && children.length > 1){
                hasCarousel = true;
            }
        }

        if (wrap.length > 0 && hasCarousel) {
            wrap.each(function () {
                var single_wrap = $(this);
                single_wrap.on("init", function () {
                    lazyLoadInstance.update();
                });

                single_wrap.slick({
                    autoplay: false,
                    arrows: true,
                    dots: true,
                    infinite: true,
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    appendDots: single_wrap.closest('.section').find('.pager'),
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: false,
                    rtl: $('html').attr('dir') === 'rtl',
                    responsive: [
                        {
                            breakpoint: 1025,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 752,
                            settings: {
                                slidesToShow: 1
                            }
                        },
                    ]
                });
            });
        }
    }
})(jQuery);